import React, { useEffect, useState } from "react";
import Layout from "../layout/layout";
import styles from "./results.module.css";
import FileDetailsInfo from "../file_details_info";
import Antiviruses from "../antiviruses";
import { Container } from "@material-ui/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Skeleton } from "antd";
import getStringsBasedLang from "../../strings/get_strings";
import UseErrorHandling, { showToastError } from "../../hook/UseErrorHandling";
import { createData } from "../../api/http-service";

export default function Results(props) {
  const [scanResult, setScanResult] = useState();
  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const token = localStorage.getItem("token");
  let id = null;
  const scanid = searchParams.get("scanid");
  const hash = searchParams.get("hash");
  const handleErrorApi = UseErrorHandling();

  useEffect(() => {
    if (scanid) {
      getResult(scanid);
    } else {
      if (hash) {
        createData("scan/search", {
          token: token,
          hash: hash,
        })
          .then((getLastScanListResult) => {
            if (!getLastScanListResult?.success) {
              handleErrorApi(getLastScanListResult);
              return;
            }
            getResult(getLastScanListResult.data.scans[0].guid);
          })
          .catch((error) => {
            if (error?.response) {
              handleErrorApi(error?.response.data);
            }
          });
      }
    }
    return () => {
      clearInterval(id);
    };
  }, []);

  const getResult = (scan_id) => {
    createData(`scan/result/${scan_id}`, { token: token })
      .then((getScanResult) => {
        if (!getScanResult?.success) {
          handleErrorApi(getScanResult);
          return;
        }
        if (getScanResult.data.length === 0) {
          showToastError(getStringsBasedLang("general_notFound"))
          navigate("/search");
        } else {
          if (getScanResult.success && getScanResult.data.finished_at) {
            setScanResult(getScanResult.data);
          } else {
            scanResultHandler();
          }
        }
      })
      .catch((error) => {
        if (error?.response) {
          handleErrorApi(error?.response.data);
        }
      });
  };

  const scanResultHandler = () => {
    id = setInterval(() => {
      createData(`scan/result/${scanid}`, { token: token })
        .then((getScanResult) => {
          if (!getScanResult?.success) {
            handleErrorApi(getScanResult);
            clearInterval(id);
            return;
          }

          setScanResult(getScanResult.data);
          if (getScanResult.data.finished_at) {
            clearInterval(id);
          }
        })
        .catch((error) => {
          clearInterval(id);
          if (error?.response) {
            handleErrorApi(error?.response.data);
          }
        });
      
    }, 5000);
  };

  return (
    <Layout>
      <div className="flex mt-52 mb-20 justify-center">
        <div className="gradient_blue_background" />
        <Container>
          <div className="">
            <div className={`${styles.file_detail_container} px-5`}>
              {scanResult !== undefined ? (
                <FileDetailsInfo data={scanResult} guid={scanid} />
              ) : (
                <Skeleton active paragraph={4} />
              )}
            </div>
            <div>
              <div className={`${styles.file_detail_container} px-5 mt-10`}>
                {scanResult !== undefined ? (
                  <Antiviruses data={scanResult} />
                ) : (
                  <Skeleton active paragraph={4} />
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  );
}
